import {
    mapSalesChannelsForOne,
    mapSalesChannelsForList,
    mapStatesForList,
    mapStatesForOne,
    mapPlatformsForOne,
    mapProductsForOne,
} from './common';

function mapGetOneBannerData(responseData) {
    const data = {
        ...responseData,
        ...mapSalesChannelsForOne(responseData),
        ...mapStatesForOne(responseData),
        ...mapPlatformsForOne(responseData),
        ...mapProductsForOne(responseData),
    };

    if (data.published_at === null || data.published_at === undefined) {
        delete data.published_at;
    }

    return data;
}

function mapGetListBannersData(responseData) {
    return responseData.map((data) => ({
        ...data,
        ...mapSalesChannelsForList(data),
        ...mapStatesForList(data),
    }));
}

export { mapGetOneBannerData, mapGetListBannersData };
